import createPermission from 'permissions/createPermission'

import list from './list'
import upgrade from './upgrade'

export default createPermission(
    list,
    upgrade,
)